import React, { memo } from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import { Link as RouterLink, useSearchParams } from "react-router-dom"
import Button from "@material-ui/core/Button"
import { makeStyles } from "@material-ui/core/styles"
import { urlPath } from "@/utils"

const useStyles = makeStyles(() => ({
    linkContainer: {
        padding: "10px 16px",
        textDecoration: "none",
    },
}))

const OutputActive = memo((props) => {
    const { participantRole, participantUUID } = props
    const [searchParams] = useSearchParams()
    const participantPublicAccessToken = searchParams.get("token")
    const classes = useStyles()
    let outputActive
    if (!participantRole) {
        outputActive = (
            <Box my={10} mx={4} alignItems="center" display="flex" flexDirection="column" style={{ margin: "35px auto 15px" }}>
                <Typography variant="h5" component="h1" style={{ textTransform: "capitalize" }}>
                    You have opted out
                </Typography>
                <Box mt={3}>
                    <Typography> Please contact your project sponsor if you have any questions</Typography>
                </Box>
            </Box>
        )
    } else {
        // TODO: redirect to assessment page automatically
        outputActive = (
            <Box my={10} mx={4} alignItems="center" display="flex" flexDirection="column">
                <Typography variant="h5" component="h1">
                    You have set information
                </Typography>
                <Box mt={3}>
                    <Button variant="contained" color="primary" style={{ padding: "0" }}>
                        <RouterLink
                            className={classes.linkContainer}
                            to={urlPath("assessment", undefined, { participantUUID, token: participantPublicAccessToken })}
                        >
                            Go to Questionnaire
                        </RouterLink>
                    </Button>
                </Box>
            </Box>
        )
    }
    return outputActive
})

export default OutputActive
